export default {
  "": "If the loan exceeds the repayment period, your borrowed asset will incur three (3) times the interest during the overdue period. In case of a delay exceeding {'{'}{hour}{'}'} hours, your collateral assets will be liquidated to repay the borrowed amount and interest.",
  "action": "アクション",
  "AddLoan": "増加",
  "AdjustLoanFail": "担保額の調整に失敗しました。しばらくしてからもう一度お試しください。 ",
  "all": "すべて",
  "applicationRecords": "お申込み履歴",
  "apply": "申請する",
  "appResultThen": "審査結果はこちら。",
  "approvalInProgress": "審査中",
  "assets": "通貨",
  "available": "利用可能",
  "availableAssetsNewTips": "利用可能な保有資産：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"deposit\">入金</a>",
  "balance": "利用可能残高",
  "BorrowableAmountNewTips": "借入可能額：{amount} {coin}～",
  "borrowAmountNotZero": "借入額を0にすることはできません。  ",
  "borrowingAccount": "借入アカウント",
  "borrowingLimit": "借入上限",
  "botValidateErrCode101": "最低投資価格が低すぎます。",
  "botValidateErrCode102": "最低投資価格が高すぎます。",
  "botValidateErrCode103": "最高投資価格が低すぎます。",
  "botValidateErrCode104": "最高投資価格が高すぎます。",
  "botValidateErrCode105": "グリッドが少なすぎます。",
  "botValidateErrCode106": "グリッドが多すぎます。",
  "botValidateErrCode107": "投資額が低すぎて、投資要件を満たしていません。",
  "botValidateErrCode108": "投資額が高すぎて、契約の投資枠を超えています。",
  "botValidateErrCode109": "利食価格が低すぎます。",
  "botValidateErrCode110": "利食価格が高すぎます。",
  "botValidateErrCode111": "損切価格が低すぎます。",
  "botValidateErrCode112": "損切価格が高すぎます。",
  "botValidateErrCode113": "参入価格が低すぎます。",
  "botValidateErrCode114": "参入価格が高すぎます。",
  "cancel": "いいえ",
  "cancelAll": "すべてをキャンセル",
  "cancelOrder": "キャンセル",
  "chooseVipCryptoLoans": "VIP暗号資産ローンを利用して、借入限度額を引き上げましょう。現物またはデリバティブの取引高に応じて、借入可能額が増加します。  ",
  "close": "閉じる",
  "coin": "通貨",
  "collateralAccount": "担保アカウント",
  "confirm": "はい",
  "contactOnline": "カスタマーサポートに照会する",
  "contract_account": "デリバティブアカウント",
  "createErrorCode400": "お客様から送信されたデータに不正なパラメータが含まれています。詳しくは、エラーメッセージとその詳細をご確認ください。",
  "createErrorCode401": "残高が不足しています。",
  "createErrorCode402": "ボットの作成数が上限に達しました。",
  "createErrorCode403": "禁止",
  "createErrorCode404": "リクエストされたリソースは見つかりませんでした。",
  "createErrorCode407": "お客様のアカウントタイプでは、取引ボットのサブアカウントは作成できません。",
  "createErrorCode408": "定期投資対象が重複して選択されています。",
  "createErrorCode409": "投資限度額が無効です。",
  "createErrorCode410": "投資限度額が無効です。",
  "createErrorCode411": "ボットが終了しました。",
  "createErrorCode412": "USDデリバティブアカウントに更新中",
  "createErrorCode500": "内部サーバーエラー",
  "createErrorCode501": "内部処理のタイムアウト",
  "createErrorCode503": "積立ボットは現在終了できません。買い注文をしている可能性があります。",
  "createTimes": "日時",
  "currency": "通貨",
  "currentOperationFailed": "失敗しました！もう一度お試しください。",
  "dailyRate": "日次利率",
  "dedAccManager": "専任のアカウントマネージャー",
  "deposit": "入金",
  "detail": "詳細",
  "direction": "方向",
  "earnSummary": "まとめ",
  "end": "終了時間",
  "enjoyPersonalizedVipLoan": "VIP暗号資産ローンでは、お客様一人一人に合わせたサービスをご利用いただけます。専任のアカウントマネージャーがお客様のニーズに合わせて融資額を調整し、最適な融資期間を決定いたします。",
  "enterQuantity": "数量を入力してください。",
  "EstimatedDailyInterest": "推定日次利息",
  "exceedLimitError": "プラットフォームの借入および担保限度額を超えています。",
  "exceedPlatformBorrowLimit": "プラットフォームの借入限度額を超えています。",
  "exceedPlatformLimit": "プラットフォームの担保限度額を超えています。",
  "expiryDate": "満期日",
  "failed": "失敗",
  "FAQNewTips": "Bybitに登録済みのお客様で、資金調達アカウントまたは統合取引アカウントに資産がある場合は、Bybitローンから借り入れることができます。",
  "fiat": "法定通貨",
  "filter": "絞り込む",
  "firstPage": "ホームページ",
  "fixedRateLoan": "固定金利ローン",
  "fixedRateTerm": "固定金利/期間",
  "from": "開始時間",
  "fullRepaymentAssetReturn": "全額返済後、担保が戻されます。 ",
  "funding": "資金調達",
  "getHightLoanAmount": "借入限度額の引き上げ",
  "global_setting_quick_order_desc": "<p>1.成行注文（クイック注文）</p>\n<p>2.入力した注文数量と実際に約定された購入数量が若干異なる場合があります。</p>",
  "global_setting_quick_order_label": "クイック注文",
  "global_setting_title": "カスタム設定（現物取引に適用）",
  "gotIt": "了解",
  "hint": "備考",
  "hourlyAnnualIntRate": "毎時金利／年金利",
  "HourlyAnnualizedInterestRate": "時間/年間金利",
  "hoursAmountTips": "最低時間利率は{amount}{coin}です。注：利息は1時間単位で計算され、1時間未満は切り上げられます。",
  "idAuth": "本人確認を行う",
  "iKnow": "了解",
  "innovateQuota": "購入上限",
  "inProgress": "進行中",
  "InsufficientAvailableAssetsTips": "担保が不足しています（アカウント残高：{num} {token}）。<a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">入金</a>してください。",
  "insufficientLendingPoolDemand": "多数の借入申請をいただいているため、現在利用できる資金プールが限られています。今しばらくお待ちください。",
  "interestRatesHourlyYearly": "利率（時間/年）",
  "introUTAUMA": "統合取引",
  "kline": "チャート",
  "lastSixMonthsCommissionRecords": "過去6か月の注文履歴のみを表示",
  "lendingAnnouncements": "レンディングと積立ステーキングの統合のお知らせ",
  "leverage": "レバレッジ",
  "leverage_off_trade_tip": "レバレッジ取引を行うには、まずレバレッジ機能を有効にしてください。",
  "leverageCloseErrInfo": "処理に失敗しました。すべての返済を完了してから、マージン取引をオフにしてください。",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leverageLoanTips": "USDデリバティブアカウントの必要証拠金と維持証拠金の利用率がしきい値を超えているため、このアクションは完了できません。",
  "leverageTryAgain": "システムエラーです。後でもう一度お試しください。",
  "limitGreaterNoNeedRequest": "借入限度額が希望額を上回っているため、リクエストを再提出いただく必要はありません。",
  "liquidate": "強制決済済み",
  "liquidationErrorInfo": "処理に失敗しました。お客様のアカウントで強制決済がトリガーされました。",
  "LiquidationPrice": "強制決済価格",
  "loan": "借入",
  "loan_accont_assets_tip": "利用可能残高不足",
  "loan_account_tip": "誠に恐れ入りますが、お客様のアカウントはセキュリティ上の理由から制限されており、現在暗号資産ローンをご利用いただけません。ご不明な点がありましたら、カスタマーサービスまでお問い合わせください。",
  "loan_agreement": "<a href={url} target=\"_blank\" class={className}>暗号資産ローンサービス利用規約</a>に同意します。",
  "loan_all_order": "すべてのローン",
  "loan_amount": "最大借入額",
  "loan_amount_less_tip": "借入需要の急増により、借入可能な資産が現在不足しています。借入金額を減らすか、後ほどお試しください。",
  "loan_amount_pledge_less_tip": "借入需要の急増により、担保額を現在制限しています。担保額を減らすか、後ほどお試しください。",
  "loan_apply": "暗号資産ローンを申し込む",
  "loan_apply_time": "借入期限",
  "loan_assets_debt": "アカウント概要",
  "loan_assets_transfer": "借入資産の振替先：",
  "loan_assets_transfer_layer": "借入資金は{account}に振替されます",
  "loan_assets_transfer_tip": "借入資金は、該当するアカウントに自動振替されます",
  "loan_available_funding_tip": "利用可能な数量 (資金調達): <span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"deposit\">入金</a>",
  "loan_available_funding_tip_new": "利用可能な資金：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"deposit\">入金</a>",
  "loan_available_spot_assets": "ご利用可能な現物資産",
  "loan_available_spot_less": "現物資産が不足しています。残高{num} {token}。<a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">入金</a>してください。",
  "loan_available_spot_tip": "ご利用可能な現物資産：<span>{num} {token}</span><a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"deposit\">入金</a>",
  "loan_available_spot_tip_new": "利用可能な現物残高：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"deposit\">入金</a>",
  "loan_back_assets": "担保は現物アカウントに戻されます",
  "loan_borrow_tips": "*借入資産は資金調達アカウントに振替えられます。",
  "loan_confirm_amount": "借入金額",
  "loan_confirm_order": "詳細を確認",
  "loan_confirm_tips": "*借入資産は資金調達アカウントに振替えられます。",
  "loan_cope_interest": "未払利息",
  "loan_cope_principal": "未払元本",
  "loan_cope_total": "合計未払金",
  "loan_covering_position_tip": "担保額が調整中のため、現在支払いはできません。",
  "loan_currency": "借り入れる暗号資産",
  "loan_debt_assets": "借り入れた暗号資産",
  "loan_debt_total": "合計未払金",
  "loan_edit_pledge_amount": "担保金額の調整",
  "loan_exceed_pledge_rate_tip": "ローンが承認されるとLTVがマージンコール比率を超えるため、ローンの申請は却下されました。",
  "loan_failed": "失敗しました",
  "loan_high_exchange_rate": "高いローン資産価値比率（LTV）",
  "loan_high_risk": "高リスク",
  "loan_hour_day_rate": "時間利率/日次利率",
  "loan_hour_day_rate_tip": "1時間あたりの最低金利は{precision} {token}です。<br />\n\n日次金利：{dayRate}<br />\n年次金利：{yearRate}<br />\n\n注意：金利は1時間単位で計算され、1時間未満は1時間に繰り上げて計算されます。",
  "loan_init_ltv": "初期LTV",
  "loan_init_ltv_tip": "初期LTVによって最初に借り入れることのできる通貨の額が決まります。初期LTVは、担保の種類によって変わる場合があります。",
  "loan_init_ltv_title": "初期ローン資産価値比率（LTV）",
  "loan_input_amount": "借入金額を入力してください",
  "loan_input_pledge_amount": "ローンの担保にする金額を入力してください",
  "loan_instant_credit": "借入資産の即時受取り",
  "loan_interest_accruing": "利息計算中",
  "loan_interest_accruing_tip": "利息を計算中です。現在支払いはできません。",
  "loan_interest_rate": "利率",
  "loan_interest_time": "利息発生期間",
  "loan_interest_time_unit": "{num}時間",
  "loan_kyc_tip": "暗号資産ローン申請前に本人確認（KYC）レベル1を完了してください。",
  "loan_limit": "貸付期間",
  "loan_limit_day": "{num}日",
  "loan_limit_tip": "利息は1時間単位で計算されます。ローンは締め切りまでにいつでも繰上返済が可能です。貸付期間終了後、遅延損害金は時間単位の利息の{multiple}倍となります。返済期限から{time}時間経過しても返済が行われない場合、返済のために担保が強制決済されます。",
  "loan_limit_tip_new": "ご返済期限内にご返済いただけない場合、延滞期間中、借入資産に通常の({num})倍の利息がかかります。{hour}時間以上の遅延が発生した場合、担保資産は強制決済され借入金額と利息は返済されます。",
  "loan_liquidate_ltv": "強制決済LTV",
  "loan_liquidate_ltv_tip": "LTV（借入額÷担保額）が一定金額に達した場合、Bybitが担保資産を強制決済し、借入額と金利を全額返済させていただきます。",
  "loan_liquidate_pledge_tip": "強制決済中です。現在担保額の調整はできません。",
  "loan_liquidate_tip": "強制決済中です。現在支払いはできません。",
  "loan_liquidation": "強制決済中",
  "loan_liquidation_price": "強制決済価格",
  "loan_login": "ログインして借入",
  "loan_login_tip": "ローンを利用するためには、<a href={loginUrl} class={loginClass}>ログイン</a>もしくは<a href={registerUrl} class={registerClass}>登録</a>を行なってください。",
  "loan_low_risk": "低リスク",
  "loan_lt_user_tip": "注意：暗号資産ローンが機関レンディングのLTVに影響する場合があります。",
  "loan_manual": "マニュアル",
  "loan_max_amount": "最大額：{num} {token}",
  "loan_max_amount_tip": "借入限度額に達しているため、借入はできません。",
  "loan_max_amount_tip2": "{coin}の借入金額が最大借入額である{num} {coin}を超えてしまうため、借入金額を減らすか、返済してください。",
  "loan_max_pledge_tip": "担保額の上限に達しているため、借入不可能です。",
  "loan_max_pledge_tip2": "{coin}の最大担保額は{num} {coin}です。これを超えないよう担保額を減らしてください。",
  "loan_middle_risk": "中リスク",
  "loan_min_amount": "最小額：{num} {token}",
  "loan_min_amount_tip": "入力した暗号資産の借入額が必要最低額に達していないため、借入はできません。",
  "loan_min_pledge_amount_tip": "入力した暗号資産の担保額が必要最低額に達していないため、借入はできません。",
  "loan_min_pledge_tip": "最低調整額は{num} {token}です。",
  "loan_no_order_tip": "現在、未返済のローンはありません。<span>暗号資産ローン</span>をお申し込みいただけます。",
  "loan_no_pledge_tip": "現在、未返済のローンはありません。<span>暗号資産ローン</span>をお申し込みいただけます。",
  "loan_now": "今すぐ借入",
  "loan_order": "借入・返済",
  "loan_order_number": "ローン番号",
  "loan_over_capital": "元本残高",
  "loan_over_interest": "利息残高",
  "loan_overdue": "返済期限超過",
  "loan_paid_off": "返済済み",
  "loan_pledge": "暗号資産ローン",
  "loan_pledge_amount": "担保額",
  "loan_pledge_assets": "担保の暗号資産",
  "loan_pledge_deposit": "担保額",
  "loan_pledge_desc": "他の資産を担保に、1種類の暗号資産を借入できます。借入資産はBybitの現物市場やデリバティブ市場で取引できるほか、資産運用やその他プラットフォームで使用したり、出金したりすることも可能です。",
  "loan_pledge_failed": "LTVの調整に失敗しました",
  "loan_pledge_processing": "LTV調整中",
  "loan_pledge_rate_after": "LTV後",
  "loan_pledge_rate_current": "現在のLTV",
  "loan_pledge_rate_success": "担保額調整済み",
  "loan_pledge_rate_success_tip": "担保額を{num} {token}増やしたため、調整済みLTV率は{rate}になりました。",
  "loan_pledge_rate_success_tip1": "You have successfully reduced your collateral by {num} {token}. Your new LTV is {ltv}.\n",
  "loan_pledge_rate_tip": "ローン資産価値比率（LTV）とは、担保として差し入れた通貨に対する借入額の割合を指します。<br />\n\n初期LTV：<span class=\"init\">{ltv1}％</span><br />\n\n初期ローン資産価値比率（LTV）は借入可能な資産の金額と、担保として差し入れた通貨との比率です。<br />\n\nマージンコールLTV：<span class=\"warning\">{ltv2}％</span><br />\nLTV（借入額÷担保額）が一定金額に達した場合、追加担保が必要になります。<br />\n\n強制決済LTV：<span class=\"liquidate\">{ltv3}％</span><br />\nLTV（借入額÷担保額）が一定金額に達した場合、Bybitが担保資産を強制決済し、借入額と金利を全額返済させていただきます。",
  "loan_pledge_total": "合計担保価格",
  "loan_pledge_total_amount": "合計担保額",
  "loan_process": "ご利用方法",
  "loan_processing": "ローン申請中",
  "loan_progress_order": "借入中",
  "loan_progress_order_qty": "お客様の借入額（{num}）",
  "loan_question1_title": "暗号資産ローンサービスの利用条件を教えてください。",
  "loan_question2_detail": "金利は1時間単位で計算され、1時間未満の借入は1時間に繰り上げて計算されます。借入を行った時点から金利が発生します。\n\n注意：金利は、借入時に表示される借入金利をもとに計算されます。\n\n金利＝借入額×1時間あたりの金利",
  "loan_question2_title": "ローンの利息はどのように計算されますか？",
  "loan_question3_detail": "返済期日前であれば、いつでも違約金なしで返済が可能です。借入額を返済後、借入時間に応じた金利のみをお支払いいただきます。",
  "loan_question3_detail2": "Bybitに登録し、現物または資金調達アカウントに担保として利用できる資金があれば借入が可能です。",
  "loan_question3_title": "事前にローンを一括または部分的に返済することはできますか？",
  "loan_question4_detail": "ローン資産価値比率（LTV）とは、担保として差し入れた通貨に対する借入額の割合を指します。 \n\nLTVの計算方法は次のとおりです。\n\nLTV＝借入額÷担保額\n\n借入額＝（未払い元本＋未払い金利＋未払い延滞金利）",
  "loan_question4_title": "ローン資産価値比率（LTV）とは何ですか？",
  "loan_question5_content": "担保資産は注文ページで調整可能です。また、いつでも担保資産を増やしてLTVを下げることもできます。",
  "loan_question5_title": "担保資産の調整方法について教えてください。",
  "loan_question6_content": "暗号資産ローンは、暗号資産イールドアービトラージ取引などの高度な戦略でもご利用になれます。暗号資産イールドアービトラージ取引は、暗号資産を低金利で借りられるプラットフォームを見つけ、別のプラットフォームで高金利で貸すという戦略です。\n\n<a href={url} target=\"_blank\">クリックして詳細を見ます</a>。",
  "loan_question6_title": "暗号資産ローンはアービトラージ取引などの他の戦略で利用できますか？",
  "loan_question7_content": "暗号資産ローンは、資産運用プロダクト、DeFiのイールドファーミング、さらにはマージン取引でご利用でき、借入資産を使って証拠金利用可能額を拡大し、レバレッジをかけたポジションの強制決済を回避することができます。\n\n<a href={url} target=\"_blank\">クリックして詳細を見ます</a>。",
  "loan_question7_title": "暗号資産ローンのご利用方法",
  "loan_received": "借入金を受け取る",
  "loan_repay_account_tip": "返済完了後、担保資産は現物アカウントに返金されます。",
  "loan_repay_anytime": "いつでも返済可能",
  "loan_repay_failed": "支払いに失敗しました",
  "loan_repay_interest": "元金と利息を返済する",
  "loan_repay_min_amount": "必要最低返済額：{num} {token}",
  "loan_repay_more_tip": "入力した返済額が未払残高の合計額を上回っています。",
  "loan_repay_processing": "支払い中",
  "loan_repay_success": "支払い完了",
  "loan_repay_success_tip": "{num} {token}の返済が完了しました。",
  "loan_repay_time": "返済期限",
  "loan_repay_time_new": "返済日時",
  "loan_repay_tips": "*全額返済後に担保は資金調達アカウントに戻されます。",
  "loan_spot_account": "現物アカウント",
  "loan_spot_assets_not_enough": "現物資産が不足しています。<a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"deposit\">入金</a>してください",
  "loan_submember_tip": "サブアカウントでは暗号資産ローンはご利用いただけません。",
  "loan_success": "借入完了",
  "loan_success_tip": "{num} {token}の借入が完了しました。",
  "loan_total_amount": "合計返済可能額",
  "loan_total_interest": "利息合計",
  "loan_total_interest_new": "推定利息合計",
  "loan_total_repay": "合計返済額",
  "loan_total_repayment": "合計返済額",
  "loan_total_repayment_new": "推定合計返済額",
  "loan_type": "種類",
  "loan_user_manual": "ご利用ガイド",
  "loan_uta_tip1": "現物アカウントの機能を資金調達アカウントに移行した後、現物アカウントでは暗号資産ローンをご利用いただけなくなります。資金調達アカウントで暗号資産ローンが利用可能になり次第、改めてお知らせいたします。",
  "loan_uta_tip2": "新しいローンは、統合取引アカウントへの更新完了後にご利用いただけます。",
  "loan_uta_tip3": "現物アカウントの機能を資金調達アカウントに移行した後、暗号資産ローンの担保調整はご利用いただけなくなります。資金調達アカウントで暗号資産ローンが利用可能になり次第、改めてお知らせいたします。",
  "loan_uta_tip4": "担保調整は、統合取引アカウントへの更新完了後にご利用いただけます。",
  "loan_uta_tip5": "統合取引アカウントへの更新完了後、返済が可能になります。",
  "loan_valuation": "推定値（{token}）",
  "loan_video_btn": "チュートリアル動画",
  "loan_video_title": "暗号資産ローンのご紹介（動画）",
  "loan_want": "借入金額",
  "loan_warning_ltv": "マージンコールLTV",
  "loan_warning_ltv_tip": "LTV（借入額÷担保額）が一定金額に達した場合、追加担保が必要になります。",
  "LoanAccountID": "連絡先情報（弊社からのご連絡用）",
  "LoanAccountNumber": "国番号も必ずご記入ください。",
  "loanAmount": "借入金額",
  "LoanAmountNew": "借入可能金額：{currentAmount}から{amount}{coin}",
  "LoanAmountNew1": "借入限度額：",
  "LoanAmountNewPledge": "利用可能担保額：{currentAmount} <a href=\"javascript:;\" class={transferClass} id=\"transfer\"> から振替</a>、または<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">を入金</a>",
  "LoanAmountNewPledge1": "担保限度額：{minAmount}－{maxAmount} {coin}",
  "LoanEmailTips": "正しい連絡先をご記入ください。",
  "LoanInterestRecords": "利息履歴",
  "LoanInterestRecordsTips": "時間利率の利息計算はフレキシブル暗号資産ローン専用になっています。",
  "loanLualityDeposit1": "現在のLTV比率が初期LTVを下回る場合のみ担保を減額できます。 ",
  "loanLualityDeposit2": "担保の減額の上限とは、LTVを初期水準に戻すために必要な金額を指します。",
  "loanLualityDeposit3": "減額後の金額が調整可能な証拠金を下回る場合、担保額を減らすことはできません。",
  "LoanMinAmount": "最小購入数量：{amount}",
  "LoanMinAmountNew": "最低借入額：",
  "LoanMinAmountTips": "最低購入金額を超える金額で購入することはできません。",
  "LoanRateTips1": "フレキシブル暗号資産ローンは1時間単位の変動金利でご利用になれます。利息は実際の借入時間で計算され、繰り上げ返済も可能です。",
  "loanRecommend": "推奨",
  "loanSureTips": "確定する前に「同意する」にチェックを入れる必要があります。",
  "loanTime": "タイムスタンプ",
  "loanType": "借り入れの種類",
  "login": "ログイン",
  "ltvAfterBorrowing": "借入後LTV",
  "ltvExceedInitial": "借入後のLTVは初期LTVの{num1}％を超えることはできません。",
  "ltvRatio": "暗号資産ローンデータ",
  "marginCallLtvRat": "マージンコールLTV率",
  "MARKET": "市場価格",
  "max": "最大",
  "maxBorrowAmount": "最大借入額",
  "maxBorrowingLimit": "最大借入額",
  "minHourlyIntRate": "毎時の最低利息は0.00000001USDTです。",
  "more": "詳しく見る",
  "myLimit": "マイ限度額",
  "network_error": "申請に失敗しました。しばらくしてから、もう一度お試しください。",
  "NEW": "アクティブ",
  "nextPage": "次へ",
  "none": "なし",
  "noRecords": "記録が見つかりません",
  "noteSystemCalculates": "注：システムは1時間単位で利息を計算し、1時間未満はまる1時間としてカウントします。",
  "OnlyDepositTransfer": "<a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">入金</a>",
  "onlyVipCanApply": "VIPのお客様のみがお申込みいただけます。",
  "operationSuccess": "成功",
  "or": "または",
  "orderBook": "取引板",
  "orderHistory": "注文履歴",
  "orderId": "注文ID",
  "orderType": "注文タイプ",
  "orLoan": "または",
  "otcErrorInfo": "お客様はすでにOTCレンディングを有効化しているため、マージン取引機能をご利用いただけません。",
  "otcFlexible": "積立",
  "other": "その他",
  "outstanding": "未払い",
  "pauseTradeTip": "{symbol}は現在取引できません。詳しくは<a href={url} target=\"_blank\">こちらのブログ記事</a>をご確認ください。",
  "pendingOrderReapply": "処理中の注文があります。完了するまで、次の発注はお控えください。  ",
  "personalizedLoanAmt": "個人向け借入金額",
  "pleaseSelect": "選択してください",
  "PledgableLimitNewTips": "担保額：{amount} {coin}",
  "prevPage": "前へ",
  "price": "価格",
  "quantity": "数量",
  "reachedAccountLimit": "アカウントの上限数に達しました。 ",
  "reachedPlatformLimit": "プラットフォームの上限数に達しました。 ",
  "reachOutContactDetails": "1営業日以内に、いただいたご連絡先までご連絡いたします。 ",
  "receivedApplication": "申込書を受け取りました。後日、再度提出しても構いません。 ",
  "ReduceLoan": "減少",
  "ReduceLoanAssets": "担保額を減らす",
  "ReduceLoanAssetsNew": "出金可能な担保額：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">振替</a>または<a href=\"javascript:;\" class={depositClass} id=\"deposit\">入金</a>",
  "ReduceLoanTip1": "担保額を減らすには、現在のLTVが初期LTVを下回らなければなりません。  ",
  "ReduceLoanTip2": "担保額を減らすには、減額後の金額が調整可能な証拠金を下回らなければなりません。",
  "ReduceLoanTip3": "現在のLTVが初期LTVを上回る場合、担保額を減らすことはできません。もう一度お試しください。 ",
  "ReduceLoanTip4": "担保額は注文ページで管理できます。担保はいつでも増やすことができます。ただし、減らす場合は現在のLTV比率が初期LTVを下回る必要があります。 ",
  "reducePledgeAssetsTransferBack": "出金担保の振替先：",
  "remainingCollateralLimit": "担保可能限度額",
  "remainingLimit": "利用可能限度額",
  "repayment": "返済",
  "reset": "リセット",
  "resetNew": "リセット",
  "result_not_found": "記録が見つかりません",
  "reverse_contract_account": "インバースアカウント",
  "reviewExpectedTime": "審査は5分程度で完了いたします。{resultLink}をご確認ください   ",
  "riskWarning": "リスクの確認",
  "sameLimitDontRepeat": "現在の借入限度額とお申し込み金額が同じです。再申請いただく必要はありません。",
  "search": "検索",
  "searchNew": "検索",
  "side": "売り/ 買い",
  "signalStatusExpired": "期限切れ",
  "sns": "ソーシャルメディア・プラットフォーム",
  "spot_account": "現物アカウント",
  "state": "ステータス",
  "status": "状態",
  "stethTradeTipText": "暗号資産ローンで担保として差し出されたstETHから、日次利回りを獲得できます。",
  "stop_limit": "利食/損切",
  "stop_limit_tips_2": "アクティブな利食・損切注文がある場合は、マージン取引を有効にすることはできません。",
  "submitApplicationLimit": "申請は1日3回までです。明日、再度申請書を提出してください。",
  "submittedSuccessfully": "送信が完了しました。",
  "success": "完了",
  "successfully": "完了",
  "sure": "sure",
  "tailoredLoanTerm": "調整後の貸付期間",
  "thanksForInterestVip": "VIP暗号資産ローンにご関心をお寄せいただきありがとうございます。",
  "times": "回",
  "timestamp": "時間",
  "title_404": "404 {'|'} Bybit現物取引  ",
  "to": "～",
  "toastTheSymbolNotExist": "お選びになった現物ペアは、現在取引に利用できません。",
  "total": "合計",
  "totalInterest": "利息総額",
  "tradeDetails": "注文詳細",
  "tradeId": "トランザクションID",
  "transfer": "資産振替",
  "uid": "お客様のアカウントID（ご連絡用）",
  "undefined": "未定",
  "unifiedAccount": "統合取引アカウント",
  "usdc_contract_account": "USDCデリバティブアカウント",
  "useMainUidToApply": "必ずメインアカウントのUIDで申請してください。",
  "variableCannotBeEmpty": "{variable}は空にすることはできません。",
  "vipCryptoLoans": "VIP暗号資産ローン",
  "vipExclusive": "VIP限定",
  "vipLoan": "VIP暗号資産ローン",
  "vipLoan1": "VIP暗号資産ローン",
  "vipLoanBorrowLimitExpire": "【Bybit】VIP Crypto Loans Borrowing Limit Expiration Notice\n\nHello.\nThe VIP borrowing limit you applied for has expired, if you need to apply again, please also go to VIP Pledge Borrowing Application;\nCoin Type: {'{'}{coin}{'}'}\nRequested amount: {'{'}{num}{'}'} {'{'}{coin}{'}'}\nExpiration date: {'{'}{date}{'}'}\n\n\nBybit Team\nPlease do not reply to system emails.",
  "vipLoanBorrowLimitNotif": "Title\n【VIP暗号資産ローン】借入限度額申請が承認されました\n\nContent\n平素よりBybitをご利用いただき、誠にありがとうございます。\n\nお客様の借入限度額申請が承認されましたので、お知らせいたします。有効期限内に、承認された限度額を必ずご使用ください。\n\n申請内容：\n通貨：{'{'}{coin}{'}'}\n承認済み借入限度額：{'{'}{num}{'}'} {'{'}{coin}{'}'}\n有効期限：{'{'}{date}{'}'}\n\n引き続きBybitをご愛顧賜りますよう、よろしくお願い申し上げます。\n\nBybit\n\n本メールは配信専用です。ご返信はお控えください。",
  "vipLoanBorrowLimitRemind": "【Bybit】VIP Crypto Loans Borrowing Limit Expiry Reminder Notice\n\nHello.\nYou have {'{'}{days}{'}'} days left for the VIP borrowing limit you applied for, please use the limit to borrow as soon as possible;\nCurrency applied for: {'{'}{coin}{'}'}\nRequested amount:  {'{'}{num}{'}'}  {'{'}{coin}{'}'}\nExpiration date: {'{'}{date}{'}'}\n\n\nBybit Team\nPlease do not reply to the system email.",
  "vipLowerInterestRate": "VIP会員になって低金利で借入しましょう。",
  "vipThresholdRights": "VIPの資格基準と限定特典については、こちらをクリックしてください。",
  "yearlyInterestRate": "年間利率",
  "yearlyInterestRateNew": "年間利率"
}